import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  Period,
  SpeedingByDriver,
  TopEventsByDriver,
  TopGeneralEvents,
  TrapDistance,
} from '../../models/dashboard';
import { DashboardService } from '../../service/dashboard.service';
import moment from 'moment';
import { first, last, map, take, tap } from 'rxjs/operators';
import {
  ChartBarData,
  ChartData,
  ChartOptions,
  ChartsData,
  ngxData,
  ngxSerie,
} from '../../models/chart';
import { UnitService } from 'src/app/units/services/unit.service';
import { Unit } from 'src/app/units/models/unit';
import { toNumber } from 'lodash';

@Component({
  selector: 'app-charts-descriptive-statistics',
  templateUrl: './charts-descriptive-statistics.component.html',
  styleUrls: ['./charts-descriptive-statistics.component.scss'],
})
export class ChartsDescriptiveStatisticsComponent implements OnInit {
  units$: BehaviorSubject<Unit[]> = new BehaviorSubject<Unit[]>([]);
  isNewData: boolean = false;
  constructor(
    private dashboardService: DashboardService,
    private unitService: UnitService
  ) {
    this.dashboardService.getIsNewDataRequested
      .pipe(
        map((_) => {
          this.allDataLoadedOfEventsByDriver = false;
          this.allDataLoadedOfExcessSpeedPerLevel = false;
          this.allDataLoadedOfGeneralEvents = false;
          this.allDataLoadedOfMileage = false;
          this.allDataLoadedOfFuel = false;
        })
      )
      .subscribe();
    unitService.getUnits
      .pipe(
        // take(2),
        // last(),
        first(),
        tap((_) => this.units$.next(_))
      )
      .subscribe();

    this.dashboardService.getRequestVehicleTripDistance
      .pipe(
        map((_) => this.filterEventsByOperationUnits(_) as TrapDistance[]),
        tap((_) => {
          if (_.length > 0) this.allDataLoadedOfMileage = true;
          this.setUnitsMileageGraphs(_);
        }),
        map((_) =>
          _.filter((T) => T.fuel < 4000000 && T.fuel > 0).map((T) => ({
            ...T,
            fuel: this.averageUnit == 'Lts' ? T.fuel : T.fuel / 3.78,
          }))
        ),
        tap((_) => {
          if (_.length > 0) this.allDataLoadedOfFuel = true;
          this.setUnitsFuelGraphs(_);
        })
      )
      .subscribe();
    this.dashboardService.getRequestTopGeneralEvents
      .pipe(
        map((_) => this.filterEventsByOperationUnits(_) as TopGeneralEvents[]),
        tap((_) => {
          if (_.length > 0 || this.isNewData)
            this.allDataLoadedOfGeneralEvents = true;
          this.setGeneralEventsGraphs(_);
        })
      )
      .subscribe();
    this.dashboardService.getRequestTopDriverEvents
      .pipe(
        map((_) => this.filterEventsByOperationUnits(_) as TopEventsByDriver[]),
        tap((_) => {
          this.showHeatMapEventsByDrivers = false;
          if (_.length > 0 || this.isNewData)
            this.allDataLoadedOfEventsByDriver = true;
          this.setTableEventsByDriver(_);
          if (this.selectEventByDriver.length > 0)
            this.setDataChartsEventsByDriver(_);
        })
      )
      .subscribe();
    this.dashboardService.getRequestSpeedingByDriver
      .pipe(
        map((_) => this.filterEventsByOperationUnits(_) as SpeedingByDriver[]),
        tap((_) => {
          if (_.length > 0 || this.isNewData)
            this.allDataLoadedOfExcessSpeedPerLevel = true;
          this.setTableOfSpeedingEventsByLevelAndDriver(_);
          if (this.selectSpeedingEventsByLevelAndDriver.length > 0)
            this.setDataChartSpeedingEventsByLevelAndGeofence(_);
        })
      )
      .subscribe();
    this.dashboardService.getUnitOperationSelected
      .pipe(
        tap((_) => {
          dashboardService.resendObservableData();
        })
      )
      .subscribe();
    dashboardService.getIsNewDataRequested
      .pipe(
        tap((_) => {
          this.isNewData = _ > 0;
        })
      )
      .subscribe();
  }
  items = [
    {
      label: 'Reportes',
      icon: 'pi pi-external-link',
      command: () => {
        window.open('/reports', '_blank');
      },
    },
  ];
  dialogChartsConfig: any[] = [];
  dialogChartsTitles: string[] = [];
  dialogChartsTotals: string[] = [];
  dialogChartsData: ChartsData[] = [];
  displayChartsInDialog: boolean = false;
  dialogChartsMoreOptions: {
    colors: string[];
    library: string;
    type: string;
  }[] = [];

  // ----- variable de kilometraje -----
  allDataLoadedOfMileage: boolean = false;
  showMoreMileageGraphs: boolean = true;
  showMileageGraphs: boolean = true;
  currentTotalMileage: number = 0;
  totalMileageBefore: number = 0;
  mileageVariation: number = 0;
  gpsMileageUnits: number = 0;
  cipiaMileageUnits: number = 0;
  unitsMileageTotal: number = 0;
  mileageChartsConfig: any[] = [];
  mileageChartsTitles: string[] = [];
  mileageChartsTotals: { top: string; all: string }[] = [];
  mileageChartsData: ChartsData[] = [];
  mileageChartsFull: ChartsData[] = [];
  // ----- variables de eventos por conductor -----
  showHeatMapEventsByDrivers: boolean = false;
  allDataLoadedOfEventsByDriver: boolean = false;
  showMoreEventsByDriverGraphs: boolean = false;
  showEventsByDriverGraphs: boolean = true;
  eventsByDriver: {
    id: number;
    unit: Unit;
    event: string;
    events: number;
    driver: string;
    driverId: number;
    nameEvent: string;
  }[] = [];
  selectEventByDriver: {
    id: number;
    unit: Unit;
    event: string;
    events: number;
    driver: string;
    driverId: number;
    nameEvent: string;
  }[] = [];
  driverEvents: {
    id: number;
    units: Unit[];
    events: number;
    driver: string;
    driverId: number;
    idOperation: number;
    operation: string;
  }[] = [];
  rawEventsByDriver: TopEventsByDriver[] = [];
  showTableOfEventsByDriver: boolean = false;
  eventsByDriverChartsConfig: any[] = [];
  eventsByDriverChartsTitles: string[] = [];
  eventsByDriverChartsTotals: { top: string; all: string }[] = [];
  eventsByDriverChartsData: (ChartsData | ngxSerie[])[] = [];
  eventsByDriverChartsMoreOptions: {
    colors: string[];
    library: string;
    type: string;
  }[] = [];
  eventsByDriverChartsFull: ChartData[] = [];
  // ----- variables de eventos generales -----
  allDataLoadedOfGeneralEvents: boolean = false;
  showMoreGeneralEventsGraphs: boolean = true;
  showGeneralEventsGraphs: boolean = true;
  generalEventsChartsConfig: any[] = [];
  generalEventsChartsTitles: string[] = [];
  generalEventsChartsTotals: { top: string; all: string }[] = [];
  generalEventsChartsData: ChartsData[] = [];
  generalEventsNgxChartsData: ngxSerie[] = [];
  generalEventsChartsFull: ChartsData[] = [];

  // ----- variables de exceso de velocidad -----
  allDataLoadedOfExcessSpeedPerLevel: boolean = false;
  showMoreExcessSpeedPerLevelGraphs: boolean = false;
  showExcessSpeedPerLevelGraphs: boolean = true;
  showTableOfSpeedingEventsByLevelAndDriver: boolean = true;
  speedingEventsByLevelAndDriver: {
    id: number;
    event: string;
    level: string[];
    events: number[];
    driver: string;
    driverId: number;
  }[] = [];
  selectSpeedingEventsByLevelAndDriver: {
    id: number;
    event: string;
    level: string[];
    events: number[];
    driver: string;
    driverId: number;
  }[] = [];
  rawSpeedingEventsByLevelAndDriver: SpeedingByDriver[] = [];
  excessSpeedPerLevelChartsConfig: any[] = [];
  excessSpeedPerLevelChartsTitles: string[] = [];
  excessSpeedPerLevelChartsTotals: { top: string; all: string }[] = [];
  excessSpeedPerLevelChartsData: ChartData[] = [];
  excessSpeedPerLevelChartsFull: ChartData[] = [];
  // ----- variable de Combustible -----
  allDataLoadedOfFuel: boolean = false;
  showMoreFuelGraphs: boolean = true;
  showFuelGraphs: boolean = true;
  currentTotalFuel: number = 0;
  totalFuelBefore: number = 0;
  fuelVariation: number = 0;
  gpsFuelUnits: number = 0;
  cipiaFuelUnits: number = 0;
  unitsFuelTotal: number = 0;
  averageUnit: string = 'Lts';
  fuelChartsConfig: any[] = [];
  fuelChartsTitles: string[] = [];
  fuelChartsTotals: { top: string; all: string }[] = [];
  fuelChartsData: ChartsData[] = [];
  fuelChartsFull: ChartsData[] = [];

  // ----- -----
  products = [
    { code: 1, name: 'jesus', category: 'dev', quantity: 5 },
    { code: 2, name: 'alberth', category: 'dev', quantity: 4 },
    { code: 3, name: 'danna', category: 'dev', quantity: 7 },
    { code: 4, name: 'percy', category: 'dev', quantity: 6 },
    { code: 1, name: 'jesus', category: 'dev', quantity: 5 },
    { code: 2, name: 'alberth', category: 'dev', quantity: 4 },
    { code: 3, name: 'danna', category: 'dev', quantity: 7 },
    { code: 4, name: 'percy', category: 'dev', quantity: 6 },
    { code: 1, name: 'jesus', category: 'dev', quantity: 5 },
    { code: 2, name: 'alberth', category: 'dev', quantity: 4 },
    { code: 3, name: 'danna', category: 'dev', quantity: 7 },
    { code: 4, name: 'percy', category: 'dev', quantity: 6 },
    { code: 1, name: 'jesus', category: 'dev', quantity: 5 },
    { code: 2, name: 'alberth', category: 'dev', quantity: 4 },
    { code: 3, name: 'danna', category: 'dev', quantity: 7 },
    { code: 4, name: 'percy', category: 'dev', quantity: 6 },
  ];
  ngOnInit(): void {}
  coloresGenerados: string[] = [];

  // -----Functions-----
  generarColorAleatorio(): string {
    let nuevoColor: string = '';

    const generarColor = () => {
      let color = '#' + Math.floor(Math.random() * 16777215).toString(16);
      return color.padStart(7, '#');
    };
    const compararColores = (c1: string, c2: string) => {
      const rgb1 = hexToRgb(c1);
      const rgb2 = hexToRgb(c2);
      const umbral = 50;
      const diferencia =
        Math.abs(rgb1.r - rgb2.r) +
        Math.abs(rgb1.g - rgb2.g) +
        Math.abs(rgb1.b - rgb2.b);
      return diferencia < umbral;
    };
    const hexToRgb = (hex: string) => {
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return { r, g, b };
    };
    nuevoColor = generarColor();
    this.coloresGenerados.push(nuevoColor);
    return nuevoColor;

    // return () => {
    //   do {
    //     nuevoColor = generarColor();
    //   } while (coloresGenerados.some((c) => compararColores(c, nuevoColor)));
    //   coloresGenerados.push(nuevoColor);
    //   return nuevoColor;
    // };
  }
  filterEventsByOperationUnits(
    _: (
      | TrapDistance
      | TopEventsByDriver
      | TopGeneralEvents
      | SpeedingByDriver
    )[]
  ): (
    | TrapDistance
    | TopEventsByDriver
    | TopGeneralEvents
    | SpeedingByDriver
  )[] {
    const u = this.dashboardService.operation$.getValue().map((t) => t.code);
    if (u.length > 0) {
      const units = this.units$
        .getValue()
        .filter((unit) => u.includes(unit.idOperation))
        .map((unit) => unit.GNSSIMEI);
      return _.filter((T) => units.includes(T.imei));
    } else {
      return _;
    }
  }
  getRatioClass(length: number): string {
    return `w-100 ratio ratio-1x${~~(length / 100) * 3}`;
  }

  // -----Funtions of Millaje-----
  toggleShowMileageGraphs(): void {
    this.showMileageGraphs = !this.showMileageGraphs;
  }
  toggleShowMoreMileageGraphs(): void {
    this.showMoreMileageGraphs = !this.showMoreMileageGraphs;
  }
  showChartInDialog(
    chart: ChartsData,
    config: any,
    title: string,
    totals: string = '-'
  ) {
    this.dialogChartsData = [chart];
    this.dialogChartsConfig = [config];
    this.dialogChartsTitles = [title];
    this.dialogChartsTotals = [totals];
    this.displayChartsInDialog = true;
  }
  setUnitsMileageGraphs(_: TrapDistance[]) {
    this.mileageChartsConfig = [];
    this.mileageChartsTitles = [];
    this.mileageChartsData = [];
    this.mileageChartsFull = [];
    this.mileageChartsTotals = [];
    this.setChartUnitsMileage(_);
    this.setChartOfUnitsWithThelLowesttMileage(_);
    this.setChartOfUnitsWithTheHighestMileage(_);
    this.setChartGpsUnitsMileage(_);
    this.setChartCipiaMileageUnits(_);
  }
  setChartUnitsMileage(_: TrapDistance[]): void {
    const units: { imei: string; k: number }[] = [];
    _.map((T) => {
      let U = units.find((G) => G.imei == T.imei);
      if (U) {
        U.k += T.distanceCAN || T.distance || 0;
      } else {
        units.push({
          imei: T.imei,
          k: T.distanceCAN || T.distance || 0,
        });
      }
    });
    this.unitsMileageTotal = units.length;
    this.currentTotalMileage = toNumber(units.reduce((Ks, T) => Ks + T.k, 0));
    this.totalMileageBefore = 9000;
    this.cipiaMileageUnits = units.filter((T) =>
      T.imei.toString().toUpperCase().startsWith('E')
    ).length;
    this.gpsMileageUnits = units.filter(
      (T) => !T.imei.toString().toUpperCase().startsWith('E')
    ).length;
    this.mileageVariation = Math.floor(
      ((this.currentTotalMileage - this.totalMileageBefore) /
        this.totalMileageBefore) *
        100
    );
  }
  setChartOfUnitsWithTheHighestMileage(_: TrapDistance[]): void {
    const Us = this.units$.getValue();
    let chartFullOfUnitsWithTheHighestMileage: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let chartOfUnitsWithTheHighestMileage: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    chartFullOfUnitsWithTheHighestMileage.datasets.push({
      type: 'horizontalBar',
      label: 'Kilometraje',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartOfUnitsWithTheHighestMileage.datasets.push({
      type: 'horizontalBar',
      label: 'Kilometraje',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { id: string; units: { u: Unit; k: number }[] }[] = [];
    _.map((T) => {
      const U = Us.find((_U) => _U.GNSSIMEI == T.imei);
      if (U) {
        let u = units.find((G) => G.id == U.unitId);
        if (u) {
          let _u = u.units.find((unit) => unit.u.GNSSIMEI == T.imei);
          if (_u) {
            _u.k += T.distanceCAN || T.distance || 0;
          } else {
            u.units.push({ u: U, k: T.distanceCAN || T.distance || 0 });
          }
        } else {
          units.push({
            id: U.unitId.toString(),
            units: [{ u: U, k: T.distanceCAN || T.distance || 0 }],
          });
        }
      }
    });
    const sortedUnits = units
      .map((group) => ({
        ...group,
        units: group.units.sort((a, b) =>
          a.u.GNSSIMEI.localeCompare(b.u.GNSSIMEI)
        ),
      }))
      .sort(
        (a, b) =>
          a.units.reduce((sum, item) => (item.k > sum ? item.k : sum), 0) -
          b.units.reduce((sum, item) => (item.k > sum ? item.k : sum), 0)
      );
    let totalAll: number = 0;
    let totalTop: number = 0;
    sortedUnits.reverse().map((T) => {
      chartFullOfUnitsWithTheHighestMileage.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.k > max ? item.k : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartFullOfUnitsWithTheHighestMileage.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalAll += parseFloat(
        T.units.reduce((max, item) => (max += item.k), 0).toFixed(8)
      );
    });
    sortedUnits.slice(0, 10).map((T) => {
      chartOfUnitsWithTheHighestMileage.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.k > max ? item.k : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartOfUnitsWithTheHighestMileage.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalTop += parseFloat(
        T.units.reduce((max, item) => (max += item.k), 0).toFixed(8)
      );
    });
    this.mileageChartsData.push(chartOfUnitsWithTheHighestMileage);
    this.mileageChartsFull.push(chartFullOfUnitsWithTheHighestMileage);
    this.mileageChartsConfig.push({});
    this.mileageChartsTotals.push({
      top: totalTop.toFixed(2) + ' km',
      all: totalAll.toFixed(2) + ' km',
    });
    this.mileageChartsTitles.push('Top unidades con mayor kilometraje');
  }
  setChartOfUnitsWithThelLowesttMileage(_: TrapDistance[]): void {
    const Us = this.units$.getValue();
    let chartFullOfUnitsWithThelLowesttMileage: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    chartFullOfUnitsWithThelLowesttMileage.datasets.push({
      type: 'horizontalBar',
      label: 'Kilometraje',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartOfUnitsWithThelLowesttMileage: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    chartOfUnitsWithThelLowesttMileage.datasets.push({
      type: 'horizontalBar',
      label: 'Kilometraje',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { id: string; units: { u: Unit; k: number }[] }[] = [];
    _.map((T) => {
      const U = Us.find((_U) => _U.GNSSIMEI == T.imei);
      if (U) {
        let u = units.find((G) => G.id == U.unitId);
        if (u) {
          let _u = u.units.find((unit) => unit.u.GNSSIMEI == T.imei);
          if (_u) {
            _u.k += T.distanceCAN || T.distance || 0;
          } else {
            u.units.push({ u: U, k: T.distanceCAN || T.distance || 0 });
          }
        } else {
          units.push({
            id: U.unitId.toString(),
            units: [{ u: U, k: T.distanceCAN || T.distance || 0 }],
          });
        }
      }
    });
    const sortedUnits = units
      .map((group) => ({
        ...group,
        units: group.units.sort((a, b) =>
          a.u.GNSSIMEI.localeCompare(b.u.GNSSIMEI)
        ),
      }))
      .sort(
        (a, b) =>
          a.units.reduce((sum, item) => (item.k > sum ? item.k : sum), 0) -
          b.units.reduce((sum, item) => (item.k > sum ? item.k : sum), 0)
      );
    let totalAll: number = 0;
    let totalTop: number = 0;
    sortedUnits.map((T) => {
      chartFullOfUnitsWithThelLowesttMileage.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.k > max ? item.k : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartFullOfUnitsWithThelLowesttMileage.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalAll += parseFloat(
        T.units.reduce((max, item) => (max += item.k), 0).toFixed(8)
      );
    });
    sortedUnits.slice(0, 10).map((T) => {
      chartOfUnitsWithThelLowesttMileage.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.k > max ? item.k : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartOfUnitsWithThelLowesttMileage.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalTop += parseFloat(
        T.units.reduce((max, item) => (max += item.k), 0).toFixed(8)
      );
    });
    this.mileageChartsData.push(chartOfUnitsWithThelLowesttMileage);
    this.mileageChartsFull.push(chartFullOfUnitsWithThelLowesttMileage);
    this.mileageChartsConfig.push({});
    this.mileageChartsTotals.push({
      top: totalTop.toFixed(2) + ' km',
      all: totalAll.toFixed(2) + ' km',
    });
    this.mileageChartsTitles.push('Top unidades con menor kilometraje');
  }
  setChartGpsUnitsMileage(_: TrapDistance[]): void {
    let chartFullGpsMileageUnits: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    chartFullGpsMileageUnits.datasets.push({
      type: 'horizontalBar',
      label: 'kilometraje - GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartGpsMileageUnits: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    chartGpsMileageUnits.datasets.push({
      type: 'horizontalBar',
      label: 'kilometraje - GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { imei: string; k: number }[] = [];
    _.filter((T) => T.imei.charAt(0) != 'E').map((T) => {
      let U = units.find((G) => G.imei == T.imei);
      if (U) {
        U.k += T.distanceCAN || T.distance || 0;
      } else {
        units.push({
          imei: T.imei,
          k: T.distanceCAN || T.distance || 0,
        });
      }
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    units
      .sort((a, b) => a.k - b.k)
      .reverse()
      .map((T) => {
        chartFullGpsMileageUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.k.toFixed(2)))
        );
        chartFullGpsMileageUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalAll += parseFloat(T.k.toFixed(8));
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartGpsMileageUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.k.toFixed(2)))
        );
        chartGpsMileageUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalTop += parseFloat(T.k.toFixed(8));
      });
    this.mileageChartsData.push(chartGpsMileageUnits);
    this.mileageChartsFull.push(chartFullGpsMileageUnits);
    this.mileageChartsConfig.push({});
    this.mileageChartsTotals.push({
      top: totalTop.toFixed(2) + ' km',
      all: totalAll.toFixed(2) + ' km',
    });
    this.mileageChartsTitles.push('Top unidades GPS con mayor kilometraje');
  }
  setChartCipiaMileageUnits(_: TrapDistance[]): void {
    let chartFullCipiaMileageUnits: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    chartFullCipiaMileageUnits.datasets.push({
      type: 'horizontalBar',
      label: 'kilometraje - Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartCipiaMileageUnits: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    chartCipiaMileageUnits.datasets.push({
      type: 'horizontalBar',
      label: 'kilometraje - Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { imei: string; k: number }[] = [];
    _.filter((T) => T.imei.charAt(0) == 'E').map((T) => {
      let U = units.find((E) => E.imei == T.imei);
      if (U) {
        U.k += T.distanceCAN || T.distance || 0;
      } else {
        units.push({
          imei: T.imei,
          k: T.distanceCAN || T.distance || 0,
        });
      }
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    units
      .sort((a, b) => a.k - b.k)
      .reverse()
      .map((T) => {
        chartFullCipiaMileageUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.k.toFixed(2)))
        );
        chartFullCipiaMileageUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalAll += parseFloat(T.k.toFixed(8));
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartCipiaMileageUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.k.toFixed(2)))
        );
        chartCipiaMileageUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalTop += parseFloat(T.k.toFixed(8));
      });
    this.mileageChartsData.push(chartCipiaMileageUnits);
    this.mileageChartsFull.push(chartFullCipiaMileageUnits);
    this.mileageChartsConfig.push({});
    this.mileageChartsTotals.push({
      top: totalTop.toFixed(2) + ' km',
      all: totalAll.toFixed(2) + ' km',
    });
    this.mileageChartsTitles.push(
      'Top unidades Fatiga 360 con mayor kilometraje'
    );
  }
  // -----Funtions of Fuel-----
  toggleShowFuelGraphs(): void {
    this.showFuelGraphs = !this.showFuelGraphs;
  }
  toggleShowMoreFuelGraphs(): void {
    this.showMoreFuelGraphs = !this.showMoreFuelGraphs;
  }
  setUnitsFuelGraphs(_: TrapDistance[]) {
    this.fuelChartsConfig = [];
    this.fuelChartsTitles = [];
    this.fuelChartsTotals = [];
    this.fuelChartsData = [];
    this.fuelChartsFull = [];
    this.setChartUnitsFuel(_);
    this.setChartOfUnitsWithThelLowesttFuel(_);
    this.setChartOfUnitsWithTheHighestFuel(_);
    this.setChartGpsUnitsFuel(_);
    this.setChartCipiaFuelUnits(_);
  }
  setChartUnitsFuel(_: TrapDistance[]): void {
    const units: { imei: string; f: number }[] = [];
    _.map((T) => {
      if (T.fuel < 400000) {
        let U = units.find((G) => G.imei == T.imei);
        if (U) {
          U.f += T.fuel || 0;
        } else {
          units.push({
            imei: T.imei,
            f: T.fuel || 0,
          });
        }
      }
    });
    this.unitsFuelTotal = units.length;
    this.currentTotalFuel = toNumber(
      units.reduce((Fs, T) => Fs + T.f, 0).toFixed(2)
    );
    this.totalFuelBefore = 1000;
    this.cipiaFuelUnits = units.filter((T) =>
      T.imei.toString().toUpperCase().startsWith('E')
    ).length;
    this.gpsFuelUnits = units.filter(
      (T) => !T.imei.toString().toUpperCase().startsWith('E')
    ).length;
    this.fuelVariation = Math.floor(
      ((this.currentTotalFuel - this.totalFuelBefore) / this.totalFuelBefore) *
        100
    );
  }
  setChartOfUnitsWithTheHighestFuel(_: TrapDistance[]): void {
    const Us = this.units$.getValue();
    let chartFullOfUnitsWithTheHighestFuel: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let chartOfUnitsWithTheHighestFuel: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    chartFullOfUnitsWithTheHighestFuel.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartOfUnitsWithTheHighestFuel.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { id: string; units: { u: Unit; f: number }[] }[] = [];
    _.map((T) => {
      const U = Us.find((_U) => _U.GNSSIMEI == T.imei);
      if (U) {
        let u = units.find((G) => G.id == U.unitId);
        if (u) {
          let _u = u.units.find((unit) => unit.u.GNSSIMEI == T.imei);
          if (_u) {
            _u.f += T.fuel || 0;
          } else {
            u.units.push({ u: U, f: T.fuel || 0 });
          }
        } else {
          units.push({
            id: U.unitId.toString(),
            units: [{ u: U, f: T.fuel || 0 }],
          });
        }
      }
    });
    const sortedUnits = units
      .map((group) => ({
        ...group,
        units: group.units.sort((a, b) =>
          a.u.GNSSIMEI.localeCompare(b.u.GNSSIMEI)
        ),
      }))
      .sort(
        (a, b) =>
          a.units.reduce((sum, item) => (item.f > sum ? item.f : sum), 0) -
          b.units.reduce((sum, item) => (item.f > sum ? item.f : sum), 0)
      );
    let totalAll: number = 0;
    let totalTop: number = 0;
    sortedUnits.reverse().map((T) => {
      chartFullOfUnitsWithTheHighestFuel.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.f > max ? item.f : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartFullOfUnitsWithTheHighestFuel.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalAll += parseFloat(
        T.units.reduce((max, item) => (max += item.f), 0).toFixed(8)
      );
    });
    sortedUnits.slice(0, 10).map((T) => {
      chartOfUnitsWithTheHighestFuel.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.f > max ? item.f : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartOfUnitsWithTheHighestFuel.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalTop += parseFloat(
        T.units.reduce((max, item) => (max += item.f), 0).toFixed(8)
      );
    });
    this.fuelChartsData.push(chartOfUnitsWithTheHighestFuel);
    this.fuelChartsFull.push(chartFullOfUnitsWithTheHighestFuel);
    this.fuelChartsConfig.push({});
    this.fuelChartsTotals.push({
      top: totalTop.toFixed(2) + this.averageUnit,
      all: totalAll.toFixed(2) + this.averageUnit,
    });
    this.fuelChartsTitles.push('Top mayor consumo de combustible');
  }
  setChartOfUnitsWithThelLowesttFuel(_: TrapDistance[]): void {
    const Us = this.units$.getValue();
    let chartFullOfUnitsWithThelLowestFuel: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    chartFullOfUnitsWithThelLowestFuel.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartOfUnitsWithThelLowestFuel: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    chartOfUnitsWithThelLowestFuel.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { id: string; units: { u: Unit; f: number }[] }[] = [];
    _.map((T) => {
      const U = Us.find((_U) => _U.GNSSIMEI == T.imei);
      if (U) {
        let u = units.find((G) => G.id == U.unitId);
        if (u) {
          let _u = u.units.find((unit) => unit.u.GNSSIMEI == T.imei);
          if (_u) {
            _u.f += T.fuel || 0;
          } else {
            u.units.push({ u: U, f: T.fuel || 0 });
          }
        } else {
          units.push({
            id: U.unitId.toString(),
            units: [{ u: U, f: T.fuel || 0 }],
          });
        }
      }
    });
    const sortedUnits = units
      .map((group) => ({
        ...group,
        units: group.units.sort((a, b) =>
          a.u.GNSSIMEI.localeCompare(b.u.GNSSIMEI)
        ),
      }))
      .sort(
        (a, b) =>
          a.units.reduce((sum, item) => (item.f > sum ? item.f : sum), 0) -
          b.units.reduce((sum, item) => (item.f > sum ? item.f : sum), 0)
      );
    let totalAll: number = 0;
    let totalTop: number = 0;
    sortedUnits.map((T) => {
      chartFullOfUnitsWithThelLowestFuel.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.f > max ? item.f : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartFullOfUnitsWithThelLowestFuel.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalAll += parseFloat(
        T.units.reduce((max, item) => (max += item.f), 0).toFixed(8)
      );
    });
    sortedUnits.slice(0, 10).map((T) => {
      chartOfUnitsWithThelLowestFuel.datasets.map((d) =>
        d.data.push(
          parseFloat(
            T.units
              .reduce((max, item) => (item.f > max ? item.f : max), 0)
              .toFixed(2)
          )
        )
      );
      const U = Us.find((t) => t.unitId == T.id);
      chartOfUnitsWithThelLowestFuel.labels.push(
        U?.internalCode.split(' ')[0] + ' ' + U?.licensePlate || '-'
      );
      totalTop += parseFloat(
        T.units.reduce((max, item) => (max += item.f), 0).toFixed(8)
      );
    });
    this.fuelChartsData.push(chartOfUnitsWithThelLowestFuel);
    this.fuelChartsFull.push(chartFullOfUnitsWithThelLowestFuel);
    this.fuelChartsConfig.push({});
    this.fuelChartsTotals.push({
      top: totalTop.toFixed(2) + this.averageUnit,
      all: totalAll.toFixed(2) + this.averageUnit,
    });
    this.fuelChartsTitles.push('Top menor consumo de combustible');
  }
  setChartGpsUnitsFuel(_: TrapDistance[]): void {
    let chartFullGpsFuelUnits: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    chartFullGpsFuelUnits.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible - GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartGpsFuelUnits: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    chartGpsFuelUnits.datasets.push({
      type: 'horizontalBar',
      label: 'Combustible - GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { imei: string; f: number }[] = [];
    _.filter((T) => T.imei.charAt(0) != 'E').map((T) => {
      let U = units.find((G) => G.imei == T.imei);
      if (U) {
        U.f += T.fuel || 0;
      } else {
        units.push({
          imei: T.imei,
          f: T.fuel || 0,
        });
      }
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    units
      .sort((a, b) => a.f - b.f)
      .reverse()
      .map((T) => {
        chartFullGpsFuelUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.f.toFixed(2)))
        );
        chartFullGpsFuelUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalAll += parseFloat(T.f.toFixed(8));
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartGpsFuelUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.f.toFixed(2)))
        );
        chartGpsFuelUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalTop += parseFloat(T.f.toFixed(8));
      });
    this.fuelChartsData.push(chartGpsFuelUnits);
    this.fuelChartsFull.push(chartFullGpsFuelUnits);
    this.fuelChartsConfig.push({});
    this.fuelChartsTotals.push({
      top: totalTop.toFixed(2) + this.averageUnit,
      all: totalAll.toFixed(2) + this.averageUnit,
    });
    this.fuelChartsTitles.push('Top GPS con mayor consumo de combustible');
  }
  setChartCipiaFuelUnits(_: TrapDistance[]): void {
    let chartFullCipiaFuelUnits: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    chartFullCipiaFuelUnits.datasets.push({
      type: 'horizontalBar',
      label: 'Fuel - Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let chartCipiaFuelUnits: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    chartCipiaFuelUnits.datasets.push({
      type: 'horizontalBar',
      label: 'Fuel - Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    const units: { imei: string; f: number }[] = [];
    _.filter((T) => T.imei.charAt(0) == 'E').map((T) => {
      let U = units.find((E) => E.imei == T.imei);
      if (U) {
        U.f += T.fuel || 0;
      } else {
        units.push({
          imei: T.imei,
          f: T.fuel || 0,
        });
      }
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    units
      .sort((a, b) => a.f - b.f)
      .reverse()
      .map((T) => {
        chartFullCipiaFuelUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.f.toFixed(2)))
        );
        chartFullCipiaFuelUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalAll += parseFloat(T.f.toFixed(8));
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartCipiaFuelUnits.datasets.map((d) =>
          d.data.push(parseFloat(T.f.toFixed(2)))
        );
        chartCipiaFuelUnits.labels.push(
          this.units$.getValue().find((t) => t.GNSSIMEI == T.imei)?.unitName ||
            ''
        );
        totalTop += parseFloat(T.f.toFixed(8));
      });
    this.fuelChartsData.push(chartCipiaFuelUnits);
    this.fuelChartsFull.push(chartFullCipiaFuelUnits);
    this.fuelChartsConfig.push({});
    this.fuelChartsTotals.push({
      top: totalTop.toFixed(2) + this.averageUnit,
      all: totalAll.toFixed(2) + this.averageUnit,
    });
    this.fuelChartsTitles.push(
      'Top Fatiga 360 con mayor consumo de combustibleometraje'
    );
  }
  changeAverageUnit() {
    this.averageUnit = this.averageUnit == 'Lts' ? 'Gls' : 'Lts';
    this.dashboardService.resendTripDistanceObservableData();
  }
  // -----Funtions of Driver Events-----
  toggleShowEventsByDriverGraphs(): void {
    this.showEventsByDriverGraphs = !this.showEventsByDriverGraphs;
  }
  toggleShowMoreEventsByDriverGraphs(): void {
    this.showMoreEventsByDriverGraphs = !this.showMoreEventsByDriverGraphs;
  }
  showOfHeatMapEventsByDrivers() {
    this.showHeatMapEventsByDrivers = true;
  }
  setTableEventsByDriver(_: TopEventsByDriver[]): void {
    let id: number = 0;
    let events = this.dashboardService.eventsList$.getValue();
    this.eventsByDriver = _.reduce((Es, T) => {
      let E = Es.find((t) => t.event == T.event && t.driverId == T.driverId);
      let Us = this.units$.getValue();
      if (E) {
        E.events += T.events;
      } else {
        let u = Us.find((U) => U.GNSSIMEI == T.imei);
        if (u) {
          Es.push({
            id: id,
            unit: u,
            event: T.event,
            events: T.events,
            driver: T.driverName,
            driverId: T.driverId,
            nameEvent: events.find((e) => e.slug == T.event)?.name ?? '-',
          });
          id++;
        }
      }
      return Es;
    }, [] as { id: number; unit: Unit; event: string; events: number; driver: string; driverId: number; nameEvent: string }[])
      .sort((a, b) => a.events - b.events)
      .reverse();
    let Us = this.units$.getValue();
    this.driverEvents = _.reduce((Es, T) => {
      let U = Us.find((U) => U.GNSSIMEI == T.imei);
      let E = Es.find(
        (t) => t.driverId == T.driverId && U && U.idOperation == t.idOperation
      );
      if (E) {
        U ? E.units.push(U) : null;
        E.events += T.events;
      } else {
        let u = Us.find((U) => U.GNSSIMEI == T.imei);
        if (u) {
          Es.push({
            id: id,
            units: [u],
            events: T.events,
            driver: T.driverName,
            driverId: T.driverId,
            idOperation: u.idOperation,
            operation: u.operation,
          });
          id++;
        }
      }
      return Es;
    }, [] as { id: number; units: Unit[]; events: number; driver: string; driverId: number; idOperation: number; operation: string }[])
      .sort((a, b) => a.events - b.events)
      .reverse();
    this.showTableOfEventsByDriver = true;
  }
  setRawEventsByDriver(_: TopEventsByDriver[]): void {
    this.rawEventsByDriver = _.reduce((Es, T) => {
      let E = Es.find((t) => t.event == T.event && t.driverId == T.driverId);
      let Us = this.units$.getValue();
      if (E) {
        E.events += T.events;
      } else {
        let u = Us.find((U) => U.GNSSIMEI == T.imei);
        if (u) {
          Es.push(T);
        }
      }
      return Es;
    }, [] as TopEventsByDriver[]);
  }
  onRowSelectInTableEventsByDriver(event: any): void {
    this.showHeatMapEventsByDrivers = false;
    this.selectEventByDriver = [event.data];
    this.setDataChartsEventsByDriver();
  }
  setDataChartsEventsByDriver(_?: TopEventsByDriver[]) {
    if (!this.showMoreEventsByDriverGraphs)
      this.toggleShowMoreEventsByDriverGraphs();
    this.eventsByDriverChartsData = [];
    this.eventsByDriverChartsConfig = [];
    this.eventsByDriverChartsTitles = [];
    this.eventsByDriverChartsMoreOptions = [];
    this.eventsByDriverChartsTotals = [];
    this.eventsByDriverChartsFull = [];
    const dataEventsByDriver = _
      ? _
      : (this.filterEventsByOperationUnits(
          this.dashboardService.getCurrentTopDriverEvents()
        ) as TopEventsByDriver[]);
    this.setChartEventsByDriverAndDate(dataEventsByDriver);
    this.setDriverEventChart(dataEventsByDriver);
    this.setEventChartByDriverAndUnit(dataEventsByDriver);
  }
  /**
   * @deprecated
   * @param _
   */
  setChartEventsByDriverAndDate(_: TopEventsByDriver[]): void {
    let chartEventsByDriverAndGeofence: ngxSerie[] = [];
    let events = this.dashboardService.eventsList$.getValue();
    const Es: {
      es: number;
      e: string;
      n: string;
      u: { GNSSIMEI: string; unitName: string };
    }[] = [];
    const Us: { u: { GNSSIMEI: string; unitName: string } }[] = [];
    const units = this.units$
      .getValue()
      .map((T) => ({ GNSSIMEI: T.GNSSIMEI, unitName: T.unitName }));
    _.map((T) => {
      if (this.selectEventByDriver.some((t) => t.driverId == T.driverId)) {
        let E = Es.find((e) => e.e == T.event && T.imei == e.u.GNSSIMEI);
        if (E) {
          E.es += T.events;
        } else {
          let u = units.find((_u) => _u.GNSSIMEI == T.imei);
          if (u)
            Es.push({
              es: T.events,
              e: T.event,
              u: u,
              n: events.find((e) => e.slug == T.event)?.name ?? '-',
            });
        }
        let U = Us.find((u) => u.u.GNSSIMEI == T.imei);
        if (!U) {
          let u = units.find((_u) => _u.GNSSIMEI == T.imei);
          if (u) {
            Us.push({
              u: u,
            });
          }
        }
      }
    });
    Us.map((U) => {
      let serie: ngxSerie = {
        name: U.u.unitName,
        series: Es.map(
          (E): ngxData => ({
            name: E.n,
            value: E.u.GNSSIMEI == U.u.GNSSIMEI ? E.es : 0,
          })
        ),
      };
      chartEventsByDriverAndGeofence.push(serie);
    });
    this.generalEventsNgxChartsData = chartEventsByDriverAndGeofence;
    this.eventsByDriverChartsMoreOptions.push({
      colors: ['#00c058', '#d19c00', '#d70000'],
      library: 'NGX-Charts',
      type: 'heatMapChart',
    });
  }
  setDriverEventChart(_: TopEventsByDriver[]): void {
    let chartFullEventsByDriverOfEvent: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let chartEventsByDriverOfEvent: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let events = this.dashboardService.eventsList$.getValue();
    const eventsOfDriver: { event: string; events: number; name: string }[] =
      [];
    _.map((T) => {
      if (this.selectEventByDriver.some((t) => t.driverId == T.driverId)) {
        let eventOfDriver = eventsOfDriver.find((e) => e.event == T.event);
        if (eventOfDriver) {
          eventOfDriver.events += T.events;
        } else {
          eventsOfDriver.push({
            event: T.event,
            events: T.events,
            name: events.find((e) => e.slug == T.event)?.name ?? '-',
          });
        }
      }
    });
    chartFullEventsByDriverOfEvent.datasets.push({
      type: 'horizontalBar',
      label: this.selectEventByDriver.map((T) => T.driver).join(''),
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartEventsByDriverOfEvent.datasets.push({
      type: 'horizontalBar',
      label: this.selectEventByDriver.map((T) => T.driver).join(''),
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    eventsOfDriver
      .sort((a, b) => a.events - b.events)
      .reverse()
      .map((T) => {
        chartFullEventsByDriverOfEvent.datasets.map((d) =>
          d.data.push(T.events)
        );
        chartFullEventsByDriverOfEvent.labels.push(T.name);
        totalAll += T.events;
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartEventsByDriverOfEvent.datasets.map((d) => d.data.push(T.events));
        chartEventsByDriverOfEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.eventsByDriverChartsFull.push(chartFullEventsByDriverOfEvent);
    this.eventsByDriverChartsData.push(chartEventsByDriverOfEvent);
    this.eventsByDriverChartsConfig.push({});
    this.eventsByDriverChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.eventsByDriverChartsTitles.push('Top eventos del conductor');
  }
  setEventChartByDriverAndUnit(_: TopEventsByDriver[]): void {
    let chartFullEventsByDriverAndUnit: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    let chartEventsByDriverAndUnit: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    const units = this.units$.getValue();
    const unitsOfDriver: { es: number; eC: number; eNC: number; u: Unit }[] =
      [];
    _.map((T) => {
      if (this.selectEventByDriver.some((t) => t.driverId == T.driverId)) {
        let unitOfDriver = unitsOfDriver.find((U) => U.u.GNSSIMEI == T.imei);
        if (unitOfDriver) {
          unitOfDriver.eC += T.confirmed;
          unitOfDriver.eNC += T.notConfirmed;
          unitOfDriver.es += T.events;
        } else {
          let unit = units.find((u) => u.GNSSIMEI == T.imei);
          if (unit)
            unitsOfDriver.push({
              es: T.events,
              eC: T.confirmed,
              eNC: T.notConfirmed,
              u: unit,
            });
        }
      }
    });
    chartFullEventsByDriverAndUnit.datasets.push({
      type: 'horizontalBar',
      label: this.selectEventByDriver.map((T) => T.driver).join(''),
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartEventsByDriverAndUnit.datasets.push({
      type: 'horizontalBar',
      label: this.selectEventByDriver.map((T) => T.driver).join(''),
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    unitsOfDriver
      .sort((a, b) => a.es - b.es)
      .reverse()
      .map((T) => {
        chartFullEventsByDriverAndUnit.datasets.map((d) => d.data.push(T.es));
        chartFullEventsByDriverAndUnit.labels.push(T.u.unitName);
        totalAll += T.es;
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartEventsByDriverAndUnit.datasets.map((d) => d.data.push(T.es));
        chartEventsByDriverAndUnit.labels.push(T.u.unitName);
        totalTop += T.es;
      });
    this.eventsByDriverChartsFull.push(chartFullEventsByDriverAndUnit);
    this.eventsByDriverChartsData.push(chartEventsByDriverAndUnit);
    this.eventsByDriverChartsConfig.push({});
    this.eventsByDriverChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.eventsByDriverChartsTitles.push(
      'Top eventos por unidad del conductor'
    );
  }
  setFullDriverEventChart(_: TopEventsByDriver[]): void {} // Falta implementar
  setEventFullChartByDriverAndUnit(_: TopEventsByDriver[]): void {} // Falta implementar
  // -----Funtions of General Events-----
  toggleShowGeneralEventsGraphs(): void {
    this.showGeneralEventsGraphs = !this.showGeneralEventsGraphs;
  }
  toggleShowMoreGeneralEventsGraphs(): void {
    this.showMoreGeneralEventsGraphs = !this.showMoreGeneralEventsGraphs;
  }
  setGeneralEventsGraphs(_: TopGeneralEvents[]): void {
    this.generalEventsChartsData = [];
    this.generalEventsChartsConfig = [];
    this.generalEventsChartsTitles = [];
    this.generalEventsChartsFull = [];
    this.generalEventsChartsTotals = [];
    this.setChartsOfGeneralesEvents(_);
    this.setChartsOfCipiaEvents(_);
    this.setChartsOfGpsEvents(_);
    this.setChartsOfGeneralesEventsWithConfirmed(_);
    this.setChartsOfCipiaEventsWithConfirmed(_);
    this.setChartsOfGpsEventsWithConfirmed(_);
  }
  setChartsOfGeneralesEvents(_: TopGeneralEvents[]): void {
    let events = this.dashboardService.eventsList$.getValue();
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    const Es: { event: string; events: number; name: string }[] = [];
    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.map((T) => {
      chartFullOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
      chartFullOfGeneralesEvent.labels.push(T.name);
      totalAll += T.events;
      return T;
    })
      .slice(0, 10)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({});
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos en General');
  }
  setChartsOfCipiaEvents(_: TopGeneralEvents[]): void {
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 1,
      labels: [],
      datasets: [],
    };
    const Es: { event: string; events: number; name: string }[] = [];
    const events = this.dashboardService.eventsList$
      .getValue()
      .filter((T) => T.type == '360');

    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos Fatiga 360',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.filter((T) => events.some((event) => event.slug == T.event))
      .map((T) => {
        chartFullOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
        chartFullOfGeneralesEvent.labels.push(T.name);
        totalAll += T.events;
        return T;
      })
      .slice(0, 5)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({});
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos de Fatiga 360');
  }
  setChartsOfGpsEvents(_: TopGeneralEvents[]): void {
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 2,
      labels: [],
      datasets: [],
    };
    const Es: { event: string; events: number; name: string }[] = [];
    const events = this.dashboardService.eventsList$
      .getValue()
      .filter((T) => T.type != '360');
    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    chartOfGeneralesEvent.datasets.push({
      type: 'horizontalBar',
      label: 'Eventos GPS',
      backgroundColor: this.generarColorAleatorio(),
      data: [],
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.filter((T) => events.some((event) => event.slug == T.event))
      .map((T) => {
        chartFullOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
        chartFullOfGeneralesEvent.labels.push(T.name);
        totalAll += T.events;

        return T;
      })
      .slice(0, 5)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d) => d.data.push(T.events));
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({});
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos de GPS');
  }
  setChartsOfGeneralesEventsWithConfirmed(_: TopGeneralEvents[]): void {
    let events = this.dashboardService.eventsList$.getValue();
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 3,
      labels: [],
      datasets: [],
    };
    const Es: {
      event: string;
      events: number;
      confirmed: number;
      name: string;
    }[] = [];
    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
        E.confirmed += T.confirmed;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          confirmed: T.confirmed,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    chartOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.map((T) => {
      chartFullOfGeneralesEvent.datasets.map((d, i) => {
        if (i == 0) {
          d.data.push(T.events - T.confirmed);
        } else {
          d.data.push(T.confirmed);
        }
      });
      chartFullOfGeneralesEvent.labels.push(T.name);
      totalAll += T.events;
      return T;
    })
      .slice(0, 10)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d, i) => {
          if (i == 0) {
            d.data.push(T.events - T.confirmed);
          } else {
            d.data.push(T.confirmed);
          }
        });
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({
      tooltips: { mode: 'index', intersect: true },
      responsive: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
      },
    });
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos en General');
  }
  setChartsOfCipiaEventsWithConfirmed(_: TopGeneralEvents[]): void {
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 4,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 4,
      labels: [],
      datasets: [],
    };
    const Es: {
      event: string;
      events: number;
      confirmed: number;
      name: string;
    }[] = [];
    const events = this.dashboardService.eventsList$
      .getValue()
      .filter((T) => T.type == '360');

    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
        E.confirmed += T.confirmed;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          confirmed: T.confirmed,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos Fatiga 360 no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos Fatiga 360 confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    chartOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos Fatiga 360 no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos Fatiga 360 confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.filter((T) => events.some((event) => event.slug == T.event))
      .map((T) => {
        chartFullOfGeneralesEvent.datasets.map((d, i) => {
          if (i == 0) {
            d.data.push(T.events - T.confirmed);
          } else {
            d.data.push(T.confirmed);
          }
        });
        chartFullOfGeneralesEvent.labels.push(T.name);
        totalAll += T.events;

        return T;
      })
      .slice(0, 5)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d, i) => {
          if (i == 0) {
            d.data.push(T.events - T.confirmed);
          } else {
            d.data.push(T.confirmed);
          }
        });
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({
      tooltips: { mode: 'index', intersect: true },
      responsive: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
      },
    });
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos de Fatiga 360');
  }
  setChartsOfGpsEventsWithConfirmed(_: TopGeneralEvents[]): void {
    let chartFullOfGeneralesEvent: ChartBarData = {
      id: 5,
      labels: [],
      datasets: [],
    };
    let chartOfGeneralesEvent: ChartBarData = {
      id: 5,
      labels: [],
      datasets: [],
    };
    const Es: {
      event: string;
      events: number;
      confirmed: number;
      name: string;
    }[] = [];
    const events = this.dashboardService.eventsList$
      .getValue()
      .filter((T) => T.type != '360');
    _.map((T) => {
      let E = Es.find((e) => e.event == T.event);
      if (E) {
        E.events += T.events;
        E.confirmed += T.confirmed;
      } else {
        Es.push({
          event: T.event,
          events: T.events,
          confirmed: T.confirmed,
          name: events.find((e) => e.slug == T.event)?.name ?? '-',
        });
      }
    });
    Es.sort((a, b) => a.events - b.events).reverse();
    chartFullOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos GPS no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos GPS confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    chartOfGeneralesEvent.datasets.push(
      {
        type: 'horizontalBar',
        label: 'Eventos GPS no confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      },
      {
        type: 'horizontalBar',
        label: 'Eventos GPS confirmados',
        backgroundColor: this.generarColorAleatorio(),
        data: [],
      }
    );
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.filter((T) => events.some((event) => event.slug == T.event))
      .map((T) => {
        chartFullOfGeneralesEvent.datasets.map((d, i) => {
          if (i == 0) {
            d.data.push(T.events - T.confirmed);
          } else {
            d.data.push(T.confirmed);
          }
        });
        chartFullOfGeneralesEvent.labels.push(T.name);
        totalAll += T.events;
        return T;
      })
      .slice(0, 5)
      .map((T) => {
        chartOfGeneralesEvent.datasets.map((d, i) => {
          if (i == 0) {
            d.data.push(T.events - T.confirmed);
          } else {
            d.data.push(T.confirmed);
          }
        });
        chartOfGeneralesEvent.labels.push(T.name);
        totalTop += T.events;
      });
    this.generalEventsChartsFull.push(chartFullOfGeneralesEvent);
    this.generalEventsChartsData.push(chartOfGeneralesEvent);
    this.generalEventsChartsConfig.push({
      tooltips: { mode: 'index', intersect: true },
      responsive: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
      },
    });
    this.generalEventsChartsTotals.push({
      top: totalTop.toString() + ' eventos',
      all: totalAll.toString() + ' eventos',
    });
    this.generalEventsChartsTitles.push('Top Eventos de GPS');
  }
  // -----Funtions of excess speed per level and driver-----
  toggleShowExcessSpeedPerLevelGraphs(): void {
    this.showExcessSpeedPerLevelGraphs = !this.showExcessSpeedPerLevelGraphs;
  }
  toggleShowMoreExcessSpeedPerLevelGraphs(): void {
    this.showMoreExcessSpeedPerLevelGraphs =
      !this.showMoreExcessSpeedPerLevelGraphs;
  }
  setTableOfSpeedingEventsByLevelAndDriver(_: SpeedingByDriver[]) {
    let id: number = 0;
    this.speedingEventsByLevelAndDriver = _.reduce(
      (Ss, T) => {
        let S = Ss.find((t) => t.driverId == T.driverId);
        if (S) {
          let _t = Object.keys(T)
            .filter((key) => key.startsWith('level'))
            .sort((a, b) => a.localeCompare(b))
            .map((t) => parseInt(T[t as keyof SpeedingByDriver].toString()));
          S.events = S.events.map((e, i) => e + _t[i]);
        } else {
          Ss.push({
            id: id,
            event: '',
            level: Object.keys(T)
              .filter((k) => k.startsWith('level'))
              .sort((a, b) => a.localeCompare(b))
              .map((k) => k.replace(/([A-Z])/g, ' $1').trim()),
            events: Object.keys(T)
              .filter((key) => key.startsWith('level'))
              .sort((a, b) => a.localeCompare(b))
              .map((t) => parseInt(T[t as keyof SpeedingByDriver].toString())),
            driver: T.driverName,
            driverId: T.driverId,
          });
        }
        id++;
        return Ss;
      },
      [] as {
        id: number;
        event: string;
        level: string[];
        events: number[];
        driver: string;
        driverId: number;
      }[]
    );
    this.showTableOfSpeedingEventsByLevelAndDriver = true;
  }
  setRawSpeedingEventsByLevelAndDriver(_: SpeedingByDriver[]) {
    this.rawSpeedingEventsByLevelAndDriver = _;
  }
  onRowSelectInTableOfSpeedingEventsByLevelAndDriver(event: any) {
    this.selectSpeedingEventsByLevelAndDriver = [event.data];
    this.setDataChartSpeedingEventsByLevelAndGeofence();
  }
  setDataChartSpeedingEventsByLevelAndGeofence(_?: SpeedingByDriver[]) {
    if (!this.showMoreExcessSpeedPerLevelGraphs)
      this.toggleShowMoreExcessSpeedPerLevelGraphs();
    this.excessSpeedPerLevelChartsData = [];
    this.excessSpeedPerLevelChartsConfig = [];
    this.excessSpeedPerLevelChartsTitles = [];
    this.excessSpeedPerLevelChartsFull = [];
    this.setChartSpeedingEventsByLevelAndGeofence(
      _
        ? _
        : (this.filterEventsByOperationUnits(
            this.dashboardService.getCurrentSpeedingByDriver()
          ) as SpeedingByDriver[])
    );
  }
  setChartSpeedingEventsByLevelAndGeofence(_: SpeedingByDriver[]) {
    let chartFullSpeedingEventsByLevelAndGeofence: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    let chartSpeedingEventsByLevelAndGeofence: ChartBarData = {
      id: 0,
      labels: [],
      datasets: [],
    };
    const Es: { idG: number; g: string; es: number[]; ls: string[] }[] = [];
    _.map((T) => {
      if (
        this.selectSpeedingEventsByLevelAndDriver.some(
          (t) => t.driverId == T.driverId
        )
      ) {
        let e = Es.find((E) => E.idG == T.zoneId);
        if (e) {
          let _t = Object.keys(T)
            .filter((key) => key.startsWith('level'))
            .sort((a, b) => a.localeCompare(b))
            .map((t) => parseInt(T[t as keyof SpeedingByDriver].toString()));
          e.es = e.es.map((t, i) => t + _t[i]);
        } else {
          Es.push({
            idG: T.zoneId,
            g: T.zoneName,
            es: Object.keys(T)
              .filter((key) => key.startsWith('level'))
              .sort((a, b) => a.localeCompare(b))
              .map((t) => parseInt(T[t as keyof SpeedingByDriver].toString())),
            ls: Object.keys(T)
              .filter((k) => k.startsWith('level'))
              .sort((a, b) => a.localeCompare(b))
              .map((k) => k.replace(/([A-Z])/g, ' $1').trim()),
          });
        }
      }
    });
    const riskLevels: { name: string; color: string; data: number[] }[] = [];
    if (_.length > 0)
      Object.keys(_[0])
        .filter((k) => k.startsWith('level'))
        .sort((a, b) => a.localeCompare(b))
        .map((k, i) => `Nivel ${i + 1}`)
        .map((T) => {
          riskLevels.push({
            name: T,
            color: this.generarColorAleatorio(),
            data: [],
          });
        });
    if (_.length == 0) {
      [1, 2, 3].map((T) => {
        riskLevels.push({
          name: `Nivel ${T}`,
          color: this.generarColorAleatorio(),
          data: [],
        });
      });
    }
    riskLevels.map((T) => {
      chartFullSpeedingEventsByLevelAndGeofence.datasets.push({
        type: 'horizontalBar',
        label: T.name,
        backgroundColor: T.color,
        data: [],
      });
      chartSpeedingEventsByLevelAndGeofence.datasets.push({
        type: 'horizontalBar',
        label: T.name,
        backgroundColor: T.color,
        data: [],
      });
    });
    let totalAll: number = 0;
    let totalTop: number = 0;
    Es.sort(
      (a, b) =>
        a.es.reduce((r, t) => r + t, 0) - b.es.reduce((r, t) => r + t, 0)
    )
      .reverse()
      .map((T) => {
        chartFullSpeedingEventsByLevelAndGeofence.datasets.map((d, i) =>
          d.data.push(T.es[i])
        );
        chartFullSpeedingEventsByLevelAndGeofence.labels.push(T.g);
        totalAll += T.es.reduce((max, item) => (max += item), 0);
        return T;
      })
      .slice(0, 10)
      .map((T) => {
        chartSpeedingEventsByLevelAndGeofence.datasets.map((d, i) =>
          d.data.push(T.es[i])
        );
        chartSpeedingEventsByLevelAndGeofence.labels.push(T.g);
        totalTop += T.es.reduce((max, item) => (max += item), 0);
      });
    this.excessSpeedPerLevelChartsConfig.push({
      tooltips: { mode: 'index', intersect: true },
      responsive: true,
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
      },
    });
    this.excessSpeedPerLevelChartsTitles.push(
      'Top excesos de velocidad con nivel por geocerca'
    );
    this.excessSpeedPerLevelChartsTotals.push({
      top: totalTop.toString() + ' excesos',
      all: totalAll.toString() + ' excesos',
    });
    this.excessSpeedPerLevelChartsData.push(
      chartSpeedingEventsByLevelAndGeofence
    );
    this.excessSpeedPerLevelChartsFull.push(
      chartFullSpeedingEventsByLevelAndGeofence
    );
  }
}
